import { dateSorter } from '../sorters';
export const byStartDate = (a, b)=>dateSorter(a === null || a === void 0 ? void 0 : a.startDate, b === null || b === void 0 ? void 0 : b.startDate);
